import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { UserRole } from '../../_interfaces/enums.interface';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {
  public redirectPath: string = '/auth/login';
  public buttonText: string = 'Login';

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(
      map(user => {
        if (!user) {
          this.redirectPath = '/auth/login';
          this.buttonText = 'Login';
        } else {
          switch (user.role) {
            case UserRole.ADMIN:
              this.redirectPath = '/dashboard/admin';
              break;
            case UserRole.STARTUP:
              this.redirectPath = '/dashboard/startup';
              break;
            case UserRole.INCUBATOR:
              this.redirectPath = '/dashboard/incubator';
              break;
            default:
              this.redirectPath = '/auth/login';
              break;
          }
          this.buttonText = 'Go to Dashboard';
        }
      })
    ).subscribe();
  }

  navigate() {
    this.router.navigate([this.redirectPath]);
  }
}
